import { useI18nextInstance } from "@squide/i18next";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import type { PeriodDescriptor } from "../components/comparison/comparisonSeries.ts";
import { i18NextInstanceKey } from "../i18n/i18next.ts";

const PERIOD_LABELS_NAMESPACE = "PeriodLabels";

export function usePeriodLabel() {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation(PERIOD_LABELS_NAMESPACE, { i18n: i18nextInstance });
    const language = i18nextInstance.language;

    return useCallback(
        (descriptor: PeriodDescriptor) => {
            const formatDate = (value: string) => new Date(`${value}T00:00:00.000Z`).toLocaleDateString(language, { timeZone: "UTC", year: "numeric", month: "short", day: "numeric" });

            switch (descriptor.kind) {
                case "cycles":
                    return t("cycles", { count: descriptor.count });
                case "preset":
                    return t(`preset.${descriptor.preset}`);
                case "range": {
                    const from = descriptor.from ? formatDate(descriptor.from) : undefined;
                    const to = descriptor.to ? formatDate(descriptor.to) : undefined;

                    if (from && to) {
                        return t("range", { from, to });
                    }
                    if (from) {
                        return t("rangeFrom", { from });
                    }

                    return to ? t("rangeTo", { to }) : undefined;
                }
                case "all":
                    return undefined;
            }
        },
        [t, language]
    );
}
